import { LegalSearchInterface } from "@/components/legal-search/LegalSearchInterface";

export default function Search() {
  return (
    <div className="page-container">
      <LegalSearchInterface />
    </div>
  );
}